import { render } from "./CreateFederation.vue?vue&type=template&id=98998c2a"
import script from "./CreateFederation.vue?vue&type=script&lang=js"
export * from "./CreateFederation.vue?vue&type=script&lang=js"

import "./CreateFederation.vue?vue&type=style&index=0&id=98998c2a&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__